
import { Image, Card, Row, Col, Option, Form, AutoComplete,Table } from 'antd';
import HeadingBack from '../../../../component/HeadingBack';
import { FilePdfOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { Input, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const { Search } = Input;

const onSearch = (value) => console.log(value);
const options = [
    {
      value: 'Dr Lal PathLabs',
    },
    {
      value: 'SRL',
    },
    // {
    //   value: '',
    // },
  ];
//   interface DataType {
//     key: React.Key;
//     name: string;
//     age: number;
//     address: string;
//   }
  
  const columns = [
    {
        title: 'S.No.',
        dataIndex: 'sno',
        key: 'sno',
        className:'table_first_col',
        // render: (value, item, index) => (page - 1) * 10 + index + 1
    },
    {
      title: 'Provider Name',
      dataIndex: 'name',
 
    },
    {
        title: 'Prescribed by',
        dataIndex: 'Prescribed',
   
      },
      {
        title: 'Date',
        dataIndex: 'date',
   
      },
    {
      title: 'Attachment',
      dataIndex: 'age',
      className: "pdf_icon",
           render: (text) => <a>{text}</a>,
    },
    // {
    //   title: 'Address',
    //   dataIndex: 'address',
    // },
  ];
  
  const data = [
    {
      key: '1',
      sno: '1',
      name: 'Lal PathLabs',
      Prescribed: 'Lal PathLabs',
      date: '18 Jun 2023 2:54pm',
      age: <FilePdfOutlined />,
   
    },
    {
        key: '2',
        sno: '2',
        name: 'SRL Diagnostics',
        Prescribed: 'SRL',
        date: '18 Jun 2023 2:54pm',
        age: <FilePdfOutlined />,
        
      },
      
  
  ];
const ReportDetail = (onChange) => {
    const [form] = Form.useForm();
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    return (
        <div>
            <Row>
                <Col lg={16} md={16} sm={24} xs={24}>
                    <HeadingBack title={"Report Detail"} subHeading="" />
                </Col>
             
            </Row>
            <Card
                title=""
                bordered={false}
                className='report-d-card'
                style={{

                }}
            >
                <Search
                        placeholder="Health Id/PHR Address"
                        allowClear
                        enterButton="Search"
                        size="large"
                        className='report-detail-search'
                        onSearch={onSearch}
                    />
                    <div className="ask-report-box-label"> 
                          <h3> Patient Detail </h3>
                            </div>
                 
                <Row gutter={[24, 0]}>
                
                    <Col lg={4} md={4} sm={24} xs={24}>
                        <Image
                      preview={false}

                        
                            src="https://abym.in/dev-url/abha-person.jpg"
                        />
                    </Col>

                    <Col lg={18} md={18} sm={24} xs={24}>
                        < Form
                            form={form}
                            name="basic"
                            layout={"vertical"}
                            autoComplete="off"
                            initialValues={{ fName: "Rahul", gender: "Male", hid: "10352552121215", phr: "amit9119@abdm" }}
                        >
                            <Row gutter={[24, 0]}>
                                <Col lg={12} md={12} sm={24} xs={24}>

                                    <Form.Item
                                        label="Name"
                                        name="fName"
                                        rules={[{ required: false, message: '' }]}

                                    >
                                        <Input type="text" autoComplete="new-off" className='form-control' placeholder='' readOnly />
                                    </Form.Item>

                                </Col>
                                <Col lg={12} md={12} sm={12} xs={24}>
                                    <Form.Item
                                        label="Gender"
                                        name="gender"
                                        rules={[{ required: false, message: '' }]}
                                    >
                                        <Input type="text" autoComplete="new-off" className='form-control' placeholder='' readOnly />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={[24, 0]}>
                                <Col lg={12} md={12} sm={24} xs={24}>

                                    <Form.Item
                                        label="HID"
                                        name="hid"
                                        rules={[{ required: false, message: '' }]}

                                    >
                                        <Input type="text" autoComplete="new-off" className='form-control' placeholder='' readOnly />
                                    </Form.Item>

                                </Col>
                                <Col lg={12} md={12} sm={12} xs={24}>
                                    <Form.Item
                                        label="PHR"
                                        name="phr"
                                        rules={[{ required: false, message: '' }]}
                                    >
                                        <Input type="text" autoComplete="new-off" className='form-control' placeholder='' readOnly />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                   </Col>


                </Row>
                <div className="ask-report-box-label mt-15"> 
                          <h3>Search Facility </h3>
                            </div>
                            <div className='search-p'>

                      
                            <AutoComplete 
    style={{
      width: "100%",
    }}
    options={options}
    placeholder="Search Provider"
    className='report-detail-search'
    filterOption={(inputValue, option) =>
      option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
    }

  />

           </div>
           <div className='tableResponsive mt-10'>
                <Table
                    rowKey='UsrId'
                 
                    bordered
                    columns={columns}
                    dataSource={data}
                    pagination={{
                        current: page,
                     
                        onChange(current, pageSize) {
                            setPage(current);
                            setOffset(current == 1 ? 0 : (limit * current));
                        },
                        hideOnSinglePage: true
                    }}

                />
            </div>
            </Card>

        </div>
    )
}

export default ReportDetail